import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./App.css";
import "tailwindcss/tailwind.css";

ReactDOM.render(<App />, document.getElementById("root"));

